import { debounce } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';
export default (function (callback, delay) {
    if (delay === void 0) { delay = 500; }
    var ref = useRef();
    var debouncedCallback = useMemo(function () {
        var func = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, args);
        };
        return debounce(func, delay);
    }, [delay]);
    useEffect(function () {
        ref.current = callback;
    }, [callback, debouncedCallback]);
    return debouncedCallback;
});
//# sourceMappingURL=useDebounce.js.map